(function () {
  'use strict';

  angular.module('app').component('serviceItemCostDetail', serviceItemCostDetail());

  function serviceItemCostDetail() {
    return {
      bindings: {
        serviceItemCosts: '=',
        serviceItem: '<',
        paxRanges: '<',
        seasonSelected: '<',
        priceListSelected: '<',
        provider: '<',
        onServiceItemCostsSaved: '&',
        onServiceItemCostsCanceled: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: ServiceItemCostDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/service-item-costs/service-item-cost-detail/service-item-cost-detail.component.html',
    };
  }

  ServiceItemCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ServiceItemCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function ServiceItemCostDetailComponent(
    config,
    UtilService,
    ServiceItemCostService,

    // Angular downgraded service
    paxRangeService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.selectPaxRange = selectPaxRange;

    vm.saveServiceItemCosts = saveServiceItemCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.serviceItemCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.serviceItemCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.serviceItemCosts.forEach(function (serviceItemCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && serviceItemCost.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }
      return false;
    }

    // Set all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.schedules = [];
        paxRange.schedules.push(setPaxRangeCosts(paxRange));

        vm.paxRangesData.push(paxRange);
      });
    }

    function setPaxRangeCosts(paxRange) {
      var serviceItemCostId;
      var adultCost = '',
        childCost = 0,
        infantCost = 0,
        seniorCost = 0,
        serviceCost = 0;

      var serviceItemCost;

      // Exist service item costs
      if (vm.serviceItemCosts.length > 0) {
        for (var i = 0; i < vm.serviceItemCosts.length; i++) {
          serviceItemCost = vm.serviceItemCosts[i];

          if (serviceItemCost.pax_range_id === paxRange.id) {
            serviceItemCostId = serviceItemCost.id;

            adultCost = serviceItemCost.adult_cost;
            childCost = serviceItemCost.child_cost;
            infantCost = serviceItemCost.infant_cost;
            seniorCost = serviceItemCost.senior_cost;
            serviceCost = serviceItemCost.service_cost;
            break;
          }
        }
      }

      var schedule = {
        adult_cost: adultCost,
        child_cost: childCost,
        infant_cost: infantCost,
        senior_cost: seniorCost,
        service_cost: serviceCost,
        serviceItemCostId: null,
      };

      if (serviceItemCostId) {
        schedule.serviceItemCostId = serviceItemCost.id;
      }

      return schedule;
    }

    function saveServiceItemCosts() {
      var serviceItemCosts = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.schedules.forEach(function (schedule) {
              var cost = {
                adult_cost: schedule.adult_cost || 0,
                child_cost: schedule.child_cost || 0,
                infant_cost: schedule.infant_cost || 0,
                senior_cost: schedule.senior_cost || 0,
                service_cost: schedule.service_cost || 0,

                pax_range_id: paxRangeSelected.id,
                id: null,
              };

              if (schedule.serviceItemCostId) {
                cost.id = schedule.serviceItemCostId;
              }

              serviceItemCosts.push(cost);
            });

            break; // check
          }
        }
      }

      let params = {
        service_item_costs: serviceItemCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
        get_associated_providers: null,
      };

      if (vm.getAssociatedProvidersOnSave) {
        params.get_associated_providers = true;
      }

      vm.sendingForm = true;
      ServiceItemCostService.saveServiceItemCosts(vm.serviceItem, params, vm.editMode).then(
        function (data) {
          if (data) {
            // let obj = vm.getAssociatedProvidersOnSave ? { dataObj: data.associated_providers } : {};
            // let dataObj = vm.getAssociatedProvidersOnSave ? data.associated_providers : data.current_costs;
            // vm.onServiceItemCostsSaved({ dataObj: dataObj });

            vm.onServiceItemCostsSaved({ dataObj: data.current_costs });

            setItemOptions(data.service_item_costs[0].updated_at);

            vm.serviceItemCosts = data.service_item_costs;
            setPaxRangesData();
          }

          vm.sendingForm = false;
        }
      );
    }

    function cancel() {
      vm.onServiceItemCostsCanceled();
    }
  }
})();
